module.exports = __webpack_public_path__ + "img/mk-kuma.573f160.png";